module.exports = __webpack_public_path__ + "img/17.da8b15eb.jpg";